
import {takeEvery, takeLatest} from "redux-saga/effects";
import {LOGIN_REQUEST, LOGOUT_REQUEST} from "./modules/login/login-action-types";
import {loginRequest} from "./modules/login/login-saga";
import {logoutRequest} from "./modules/login/logout-saga";
import {LOAD_FILTERS_REQUEST, RELOAD_DATA} from "./modules/filters/filters-action-types";
import {loadFiltersRequest} from "./modules/filters/load-filters-saga";
import {LOAD_REPORT_INFO_REQUEST} from "./modules/report-info/report-info-action-types";
import {loadReportInfoRequest} from "./modules/report-info/load-report-info-request-saga";
import {
  LOAD_PRIMARY_EMOTIONS_BREAKDOWN_REQUEST, LOAD_SENTIMENT_BREAKDOWN_REQUEST,
  LOAD_TOP_WORDS_REQUEST
} from "./modules/charts/charts-action-types";
import {loadTopWordsRequest} from "./modules/charts/load-top-words-saga";
import {loadSentimentBreakdown} from "./modules/charts/load-sentiment-breakdown-saga";
import loadPrimaryEmotionsBreakdownRequest from "./modules/charts/load-primary-emotions-breakdown-saga";
import reloadData from "./modules/filters/reload-data-saga";
import {CHANGE_PAGE_REQUEST, LOAD_RESPONSES_REQUEST} from "./modules/responses/responses-action-types";
import loadResponses from "./modules/responses/load-responses-saga";
import changePage from "./modules/responses/change-page-saga";
import {LOAD_REPORTS_REQUEST} from "./modules/reports/reports-action-types";
import loadReports from "./modules/reports/load-reports-saga";
import {ADD_REPORT_REQUEST} from "./modules/add-report/add-report-action-types";
import addReport from "./modules/add-report/add-report-saga";
import {
  ADD_NOTIFICATION_REQUEST,
  REMOVE_NOTIFICATION_REQUEST
} from "./modules/notifications/notifications-action-types";
import {addNotificationRequest, removeNotificationRequest} from "./modules/notifications/notifications-saga";
import {LOAD_WORD_VERBATIMS_REQUEST} from "./modules/word-verbatims/word-verbatims-action-types";
import loadWordVerbatims from "./modules/word-verbatims/load-word-verbatims-saga";
import {LOAD_HB_INDEX_CHART_DATA_REQUEST} from "./modules/hb-index-chart/hb-index-chart-action-creators";
import {loadHbIndexChartData} from "./modules/hb-index-chart/hb-index-chart-saga";
import {ADD_WORDS_REQUEST, GET_TAXONOMY_LIST_REQUEST} from "./modules/add-words/add-words-action-types";
import {addWordsRequest, taxonomyListRequest} from "./modules/add-words/add-words-saga";
import {ADD_TAXONOMY_REQUEST} from "./modules/add-taxonomy/add-taxonomy-action-creators";
import addTaxonomy from "./modules/add-taxonomy/add-taxonomy-saga";

export default function* () {
  yield takeEvery(LOGIN_REQUEST, loginRequest);
  yield takeEvery(LOGOUT_REQUEST, logoutRequest);
  yield takeEvery(LOAD_FILTERS_REQUEST, loadFiltersRequest);
  yield takeEvery(LOAD_REPORT_INFO_REQUEST, loadReportInfoRequest);
  yield takeLatest(LOAD_TOP_WORDS_REQUEST, loadTopWordsRequest);
  yield takeLatest(LOAD_SENTIMENT_BREAKDOWN_REQUEST, loadSentimentBreakdown);
  yield takeLatest(LOAD_PRIMARY_EMOTIONS_BREAKDOWN_REQUEST, loadPrimaryEmotionsBreakdownRequest);
  yield takeLatest(RELOAD_DATA, reloadData);
  yield takeLatest(LOAD_RESPONSES_REQUEST, loadResponses);
  yield takeEvery(CHANGE_PAGE_REQUEST, changePage);
  yield takeEvery(LOAD_REPORTS_REQUEST, loadReports);
  yield takeEvery(ADD_REPORT_REQUEST, addReport);
  yield takeEvery(ADD_NOTIFICATION_REQUEST, addNotificationRequest);
  yield takeEvery(REMOVE_NOTIFICATION_REQUEST, removeNotificationRequest);
  yield takeEvery(LOAD_WORD_VERBATIMS_REQUEST, loadWordVerbatims);
  yield takeEvery(LOAD_HB_INDEX_CHART_DATA_REQUEST, loadHbIndexChartData);
  yield takeEvery(GET_TAXONOMY_LIST_REQUEST, taxonomyListRequest);
  yield takeEvery(ADD_WORDS_REQUEST, addWordsRequest);
  yield takeEvery(ADD_TAXONOMY_REQUEST, addTaxonomy);
}



// WEBPACK FOOTER //
// ./src/rootSaga.js